import { ApolloError } from '@apollo/client'

const useGraphQLErrorBoundary = (error: ApolloError) => {
  if (error) throw error
}

export default useGraphQLErrorBoundary
